<template>
<div class="start">
  <transition name="fade">
    <div v-show="showTitle" class="title-wrapper">
      <div class="title">
        <div class="title-image">
          <img class="sine" :src="assets.logoSrc" alt="WIDE AWAKE">
        </div>
        <p v-if="!isMobile" class="sine">We were expecting you, glad you made it. <br>Start your
          <router-link tag="span" class="sine-small" to="/journey">JOURNEY</router-link> now, or go directly to the
          <router-link tag="span" class="sine-small" to="/shop">SHOP</router-link>.</p>
        <p v-else class="sine">We were expecting you, glad you made it. <br>You can find the
          <router-link tag="span" class="sine-small" to="/shop">SHOP</router-link> here.</p>
      </div>
    </div>
  </transition>
  <div v-if="!showTitle" class="skip-video">
    <p class="styled-button" @click.once="showTitleEvent">skip</p>
  </div>
  <cVideo></cVideo>
</div>
</template>

<script>
// @ is an alias to /src
// import Start from '@/components/start.vue'
import cVideo from '@/components/video.vue'

export default {
  name: 'start',
  data() {
    return {
      showTitle: false,
      assets: {
        logoSrc: require('@/assets/logo.png'),
      }
    }
  },
  computed: {
    isMobile() {
      return this.$root.isMobile
    }
  },
  methods: {
    showTitleEvent() {
      this.$root.$emit("showTitle", true)
    }
  },
  mounted() {
    this.$root.$on("showTitle", (e) => this.showTitle = e)
  },
  components: {
    cVideo
  }
}
</script>

<style lang="scss">
.skip-video {
    position: fixed;
    font-size: 1.5rem;
    bottom: 1.5rem;
    text-align: center;
    z-index: 1;
    pointer-events: none;
    left: 50%;
    transform: translateX(-50%);
    p {
        pointer-events: auto;
        cursor: pointer;
    }
}
.title-wrapper {
    width: 100vw;
    height: 90vh;
    position: fixed;
    display: flex;
    top: 0;
    justify-content: center;
    align-items: center;
    color: $red;
    // pointer-events: none;
    z-index: 1;
    .title {
        max-width: 60vw;
    }
    img {
        max-width: 100%;
        padding-bottom: 4rem;
    }
    p {
        font-size: 2rem;
        line-height: 2rem;
        text-align: center;
        letter-spacing: 0.03rem;
        span {
            display: inline-block;
            border-radius: 0.7em;
            border: ridge 3px $red;
            padding: 0 0.5rem 0.5rem;
            line-height: 2rem;
            letter-spacing: 0.1rem;
            cursor: pointer;
            //border-image: linear-gradient(to bottom, red, rgba(0, 0, 0, 0)) 1 100%;
            background: linear-gradient(#000, #000), linear-gradient(to top, $red, transparent);
            border: 6px ridge transparent;
            background-repeat: no-repeat;
            background-origin: padding-box, border-box;
            background-position: 0 0;
            transition: background-position 1s ease, filter 0.5s ease;
        }
        span:hover {
            background-position: 0 -40px;
        }
        span:hover::before {
            //filter: drop-shadow(0 0px 4px $red);
            box-shadow: 0 0 20px -2px red;

        }
        span::before {
            // filter: drop-shadow(0 0px 0px $red);
            transition: box-shadow 0.5s ease;
            box-shadow: 0 0 0 0 red;
            content: "";
            position: absolute;
            top: -3px;
            bottom: -3px;
            left: -3px;
            right: -3px;

            border: 6px solid #000;
            border-radius: 0.7rem;
        }
    }
}
.title > h1 {
    // pointer-events: auto;
}

@media screen and (max-width: 600px) {
    .video-wrapper {
        height: 100vh;
        /* Fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100);
        .video-js {
            // height: auto;
        }
    }
}
</style>
